import useLocationsTable from './useLocationsTable'
import LocationsTableBody from './LocationsTableBody/LocationsTableBody'
import { ActionsTh, Table, TableWrap, Th, TheadRow } from '../styled-components'

interface LocationsTableProps {
  hidden: boolean
}

const LocationsTable = ({ hidden }: LocationsTableProps) => {
  const { rows, codeLabel, nameLabel, actionsLabel, editLabel, deleteLabel, emptyText } = useLocationsTable()

  if (hidden) return null

  return (
    <TableWrap>
      <Table>
        <thead>
          <TheadRow>
            <Th>{codeLabel}</Th>
            <Th>{nameLabel}</Th>
            <ActionsTh>{actionsLabel}</ActionsTh>
          </TheadRow>
        </thead>
        <tbody>
          <LocationsTableBody rows={rows} editLabel={editLabel} deleteLabel={deleteLabel} emptyText={emptyText} />
        </tbody>
      </Table>
    </TableWrap>
  )
}

export default LocationsTable
